import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ConfirmationModal,
  TailwindToaster,
  Pagination,
  ExportToPDF,
  Assignee,
  ChangeAssigneeOverlay,
} from "../../components";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import moment from "moment";

import axios from "../../api/axios";

const Service = () => {
  const state = useSelector((state) => state.UserReducer);
  const serviceTicketUrl = "/serviceticket";
  const serviceOptionUrl = "/service";
  const subServiceOptionUrl = "/subservice";
  const executivesUrl = "/executives";
  const navigate = useNavigate();

  const [refreshData, setRefreshData] = React.useState(false);
  const [downloadData, setDownloadData] = React.useState(false);
  const [serviceTicketData, setServiceData] = React.useState([]);
  const [cookies, setCookies] = useCookies(["user"]);
  const [currentPageIndex, setCurrentPageIndex] = React.useState(
    parseInt(cookies?.serviceCurrentPageIndex) || 0,
  );
  const [totalPages, setTotalPages] = React.useState(1);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [recordsPerPage, setRecordsPerPage] = React.useState(
    parseInt(cookies?.serviceRecordsPerPage) || 25,
  );
  const [editStatusId, setEditStatusId] = React.useState(null);

  const [channel, setChannel] = React.useState(
    cookies?.serviceChannel ? cookies?.serviceChannel : "",
  );

  React.useEffect(() => {
    setCookies("serviceChannel", channel, {
      path: "/",
      maxAge: 300,
    });
  }, [channel]);

  const exportServiceTickets = () => {
    try {
      setDownloadData(true);
      axios
        .get(serviceTicketUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
          params: {
            searchTerm,
            status: searchStatus,
            skip: currentPageIndex * recordsPerPage,
            limit: recordsPerPage,
            leadFrom,
            leadTill,
            serviceTypeId,
            subServiceTypeId,
            executiveId,
            channel,
            completeDataframe: true,
          },
        })
        .then((response) => {
          if (response.data.serviceTickets?.length > 0) {
            const excelData = [];
            response.data.serviceTickets?.map((item) => {
              const exportRecord = {
                ServiceTicketID: item.serviceTicketID,
                Date: item.leadEnteredDate.slice(0, 10),
                CustomerName: item?.addressBookId
                  ? item?.addressBookId?.prefix +
                    ". " +
                    item?.addressBookId?.firstName +
                    " " +
                    (item?.addressBookId?.lastName
                      ? item?.addressBookId?.lastName
                      : "")
                  : "--",
                Mobile: item?.addressBookId
                  ? item?.addressBookId?.crm?._id === "636751da314cd73283ec3671"
                    ? "+" +
                      item?.addressBookId?.countryCode +
                      " " +
                      item?.addressBookId?.phoneNumber.slice(0, 2) +
                      "XXX XX" +
                      item?.addressBookId?.phoneNumber.slice(7, 10)
                    : "+" +
                      item?.addressBookId?.countryCode +
                      " " +
                      item?.addressBookId?.phoneNumber
                  : "--",
                ServiceType: item?.serviceTypeId
                  ? item?.serviceTypeId?.name
                  : "--",
                SubServiceType: item?.subServiceTypeId
                  ? item?.subServiceTypeId?.name
                  : "--",
                Status: item?.status,
                SubStatus: item?.subStatusId?.name,
                enquiryDate: item?.enquiryId
                  ? item.enquiryId.leadEnteredDate.slice(0, 10)
                  : item.leadEnteredDate.slice(0, 10),
                assignee: item?.assignee
                  ? item.assignee.fullname
                    ? item.assignee.fullname
                    : item.assignee.firstname
                  : "",
              };
              excelData.push(exportRecord);
            });
            const fileType =
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            const fileExtension = ".xlsx";
            const momentTS = moment(Date()).format("YYYYMMDDHHmmss");
            const fileName = "ServiceTickets_" + momentTS;

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = {
              Sheets: { Services: worksheet },
              SheetNames: ["Services"],
            };
            const excelBuffer = XLSX.write(workbook, {
              bookType: "xlsx",
              type: "array",
            });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, fileName + fileExtension);
          } else {
            toast.error("No records to export");
          }
          setDownloadData(false);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
          setDownloadData(false);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
      setDownloadData(false);
    }
  };

  const [executives, setExecutives] = React.useState([]);

  React.useEffect(() => {
    if (executives.length > 0 && executiveId !== "") {
      const filteredExecutives = executives.filter((item) => {
        return item._id === executiveId;
      });
      // if (filteredExecutives.length === 0) {
      //   setExecutiveId("");
      // }
    }
    // console.log(state.user);
  }, [executives]);

  const getServiceTickets = () => {
    try {
      axios
        .get(serviceTicketUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
          params: {
            searchTerm,
            status: searchStatus,
            skip: currentPageIndex * recordsPerPage,
            limit: recordsPerPage,
            leadFrom,
            leadTill,
            serviceTypeId,
            subServiceTypeId,
            executiveId,
            channel,
          },
        })
        .then((response) => {
          if (response?.data?.serviceTickets?.length >= 0) {
            setServiceData(response.data.serviceTickets);
            setExecutives(response.data.executives);
            if (response.data.serviceTicketCount?.length > 0) {
              setTotalRecords(
                response.data.serviceTicketCount[0].serviceTicketCnt,
              );
              setTotalPages(
                Math.ceil(
                  response.data.serviceTicketCount[0].serviceTicketCnt /
                    recordsPerPage,
                ),
              );
            } else {
              setTotalRecords(0);
              setTotalPages(0);
            }
          }
          setRefreshData(false);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
          setRefreshData(false);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
      setRefreshData(false);
    }
  };

  const [popupId, setPopupId] = React.useState(null);
  const [popupActionName, setPopupActionName] = React.useState("DROPPED");
  const changeServiceStatusServer = (serviceTicketID, serviceTicketStatus) => {
    try {
      axios
        .put(
          serviceTicketUrl + "/status/" + serviceTicketID,
          JSON.stringify({
            status: serviceTicketStatus,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setPopupId(null);
            setRefreshData(true);
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
            getServiceTickets();
            getServiceOptions();
          } else {
            toast.error(response?.data?.message);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const changeServiceStatus = (userAccountId, targetStatus) => {
    setPopupActionName(targetStatus);
    setPopupId(userAccountId);
  };
  const closeConfirmation = () => {
    setPopupId(null);
    setEditAssigneeId(null);
  };
  const popupCallback = (canProceed) => {
    if (canProceed) changeServiceStatusServer(popupId, popupActionName);
    setPopupId(null);
  };

  const renderStatus = (status, subStatus) => {
    switch (status) {
      case "ON-HOLD":
        return (
          <span className='bg-orange-100 text-orange-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded  '>
            ON-HOLD
          </span>
        );
      case "FOLLOW-UP":
        return (
          <span className='bg-orange-100 text-orange-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded  '>
            FOLLOW-UP
          </span>
        );
      case "IN-PROCESS":
        return (
          <span className='bg-green-100 text-green-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded  '>
            {subStatus && subStatus?._id !== ""
              ? subStatus.name.length < 10
                ? subStatus.name
                : subStatus.name.slice(0, 10) + "..."
              : "IN-PROCESS"}
          </span>
        );
      case "DROPPED":
        return (
          <span className='bg-red-100 text-red-600 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded  '>
            DROPPED
          </span>
        );
      case "COMPLETED":
        return (
          <span className='bg-yellow-dark text-white text-xs font-semibold mr-2 px-2.5 py-1 rounded-sm'>
            COMPLETED
          </span>
        );
      case "DATABASE":
        return (
          <span className='bg-red-600 text-white text-xs font-semibold mr-2 px-2.5 py-1 rounded-sm'>
            DATABASE
          </span>
        );
    }
  };

  const [leadFrom, setLeadFrom] = React.useState(
    cookies.serviceOptionsLeadFrom ? cookies.serviceOptionsLeadFrom : "",
  );
  const [leadTill, setLeadTill] = React.useState(
    cookies.serviceOptionsLeadTill ? cookies.serviceOptionsLeadTill : "",
  );
  const [serviceTypeId, setServiceTypeId] = React.useState(
    cookies.serviceOptionsServiceTypeId
      ? cookies.serviceOptionsServiceTypeId
      : ["admin", "super-admin"].includes(state.user.aclGroup) ||
        state.user.department.name === "CRM"
      ? ""
      : state.user.service?._id,
  );
  const [subServiceTypeId, setSubServiceTypeId] = React.useState(
    cookies.serviceOptionsSubServiceTypeId
      ? cookies.serviceOptionsSubServiceTypeId
      : "",
  );
  const [serviceOptionsData, setServiceOptionsData] = React.useState([]);
  const [subServiceOptionsData, setSubServiceOptionsData] = React.useState([]);
  const [searchTerm, setSearchTerm] = React.useState(
    cookies.serviceOptionsSearchTerm ? cookies.serviceOptionsSearchTerm : "",
  );
  const [searchStatus, setSearchStatus] = React.useState(
    cookies.serviceOptionsSearchStatus
      ? cookies.serviceOptionsSearchStatus
      : "",
  );
  const [executiveId, setExecutiveId] = React.useState(
    cookies.serviceOptionsExecutiveId ? cookies.serviceOptionsExecutiveId : "",
  );

  const [editAssigneeId, setEditAssigneeId] = React.useState(null);

  const getServiceOptions = () => {
    try {
      axios
        .get(serviceOptionUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.services?.length > 0) {
            setServiceOptionsData(response.data.services);
            if (cookies.serviceOptionsServiceTypeId) {
              updateSubServiceOptions(serviceTypeId);
            }
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const updateSubServiceOptions = (serviceId) => {
    try {
      axios
        .get(subServiceOptionUrl + "/" + serviceId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.subservice?.length >= 0) {
            setSubServiceOptionsData(response.data.subservice);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const [updatedAssignee, setUpdatedAssignee] = React.useState(0);

  const changePageCallback = (targetPageIndex) => {
    setCurrentPageIndex(targetPageIndex);
    setCookies("serviceCurrentPageIndex", targetPageIndex, {
      path: "/",
      maxAge: 300,
    });
  };

  const changeDisplayRecordCountCallback = (targetRecordsPerPage) => {
    changePageCallback(0);
    setRecordsPerPage(targetRecordsPerPage);
    setCookies("serviceRecordsPerPage", targetRecordsPerPage, {
      path: "/",
      maxAge: 300,
    });
  };

  // const getExecutives = () => {
  //   try {
  //     axios
  //       .get(executivesUrl, {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: state.user.token,
  //         },
  //         params: {
  //           service: serviceTypeId,
  //         },
  //       })
  //       .then((response) => {
  //         if (response?.data?.users?.length > 0) {
  //           setExecutives(response.data.users);
  //         }
  //       })
  //       .catch((err) => {
  //         toast.error("Something went wrong");
  //         console.log(err);
  //       });
  //   } catch (err) {
  //     toast.error("Something went wrong");
  //     console.log(err);
  //   }
  // };

  React.useEffect(() => {
    setRefreshData(true);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    const delayDebounceFn = setTimeout(() => {
      getServiceTickets();
      getServiceOptions();
      // if (
      //   serviceTypeId !== "" ||
      //   ["admin", "super-admin"].includes(state.user.aclGroup)
      // ) {
      //   getExecutives();
      // }
      if (serviceTypeId !== "") {
        updateSubServiceOptions(serviceTypeId);
      }
    }, 700);
    setPageTitle("Services - L&L ERP");
    return () => clearTimeout(delayDebounceFn);
  }, [
    recordsPerPage,
    currentPageIndex,
    searchTerm,
    searchStatus,
    serviceTypeId,
    subServiceTypeId,
    leadFrom,
    leadTill,
    updatedAssignee,
    executiveId,
    channel,
  ]);

  const [downloadId, setDownloadId] = React.useState(false);
  const [pageTitle, setPageTitle] = React.useState("Lands & Lands ERP");
  React.useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  return (
    <>
      {editAssigneeId && (
        <ChangeAssigneeOverlay
          updatedAssignee={updatedAssignee}
          setUpdatedAssignee={setUpdatedAssignee}
          item={
            serviceTicketData.filter((item) => {
              return item?._id === editAssigneeId;
            })[0]
          }
          closeConfirmation={closeConfirmation}
        />
      )}
      {popupId && (
        <ConfirmationModal
          actionName={
            popupActionName === "DROPPED" ? (
              <strong>Drop (irreversible)</strong>
            ) : popupActionName === "ON-HOLD" ? (
              <strong>Hold</strong>
            ) : (
              <strong>Resume Servicing</strong>
            )
          }
          deleteConfirmation={popupCallback}
          moduleName={"Change Service Status"}
          itemName={"Service Record"}
          closeConfirmation={closeConfirmation}
        />
      )}
      <div className='min-h-full'>
        <main className='relative'>
          <div className='max-w-8xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='flex-1 min-w-0 px-5 lg:px-0'>
              <h2 className='mt-4 ml-1 text-xl font-semibold leading-7 text-gray-dark sm:text-xl'>
                Service Tickets{" "}
                {!["admin", "super-admin"].includes(state.user.aclGroup) &&
                  " - " + state.user.service.name}
              </h2>
            </div>
            <div className='lg:flex lg:items-center justify-between'>
              <div className='flex mt-3 sm:ml-4 ml-5 sm:mr-0 mr-5 w-full'>
                <div className='justify-end space-x-2 w-full hidden sm:flex'>
                  <div className='flex space-x-2'>
                    <div className='w-36'>
                      <label
                        htmlFor='leadFrom'
                        className='block text-xs font-medium text-gray-700'>
                        Lead From
                      </label>
                      <input
                        type='date'
                        name='leadFrom'
                        id='leadFrom'
                        defaultValue={leadFrom}
                        onChange={(event) => {
                          setCurrentPageIndex(0);
                          setCookies(
                            "serviceOptionsLeadFrom",
                            event.target.value,
                            {
                              path: "/",
                              maxAge: 300,
                            },
                          );
                          setLeadFrom(event.target.value);
                        }}
                        className=' focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm text-xs  rounded-sm'
                      />
                    </div>
                    <div className='w-36'>
                      <label
                        htmlFor='leadTill'
                        className='block text-xs font-medium text-gray-700'>
                        Lead Till
                      </label>
                      <input
                        type='date'
                        name='leadTill'
                        defaultValue={leadTill}
                        id='leadTill'
                        onChange={(event) => {
                          setCurrentPageIndex(0);
                          setCookies(
                            "serviceOptionsLeadTill",
                            event.target.value,
                            {
                              path: "/",
                              maxAge: 300,
                            },
                          );
                          setLeadTill(event.target.value);
                        }}
                        className=' focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm text-xs  rounded-sm'
                      />
                    </div>
                    {(["admin", "super-admin"].includes(state.user.aclGroup) ||
                      state.user.department?.name === "CRM") && (
                      <div className='w-40'>
                        <label
                          htmlFor='serviceTypeId'
                          className={`block text-xs font-medium text-gray-700`}>
                          Service
                        </label>

                        <select
                          id='serviceTypeId'
                          name='serviceTypeId'
                          className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                          value={serviceTypeId}
                          onChange={(event) => {
                            setCurrentPageIndex(0);
                            setCookies(
                              "serviceOptionsServiceTypeId",
                              event.target.value,
                              {
                                path: "/",
                                maxAge: 300,
                              },
                            );
                            setServiceTypeId(event.target.value);
                            updateSubServiceOptions(event.target.value);
                          }}>
                          <option key='0' value=''>
                            Select
                          </option>
                          {serviceOptionsData.length > 0 ? (
                            searchStatus === "DATABASE" ? (
                              serviceOptionsData
                                .filter((item) => {
                                  return [
                                    "632e9b76b10c8102926ba9be",
                                    "6364a88181af782ceb0133bb",
                                  ].includes(item._id);
                                })
                                .map((item) => (
                                  <option key={item?._id} value={item?._id}>
                                    {item?.name}
                                  </option>
                                ))
                            ) : (
                              serviceOptionsData.map((item) => (
                                <option key={item?._id} value={item?._id}>
                                  {item?.name}
                                </option>
                              ))
                            )
                          ) : (
                            <option key='1' value=''>
                              Loading...
                            </option>
                          )}
                        </select>
                      </div>
                    )}
                    <div className='w-36'>
                      <label
                        htmlFor='subServiceTypeId'
                        className={`block text-xs font-medium text-gray-700`}>
                        Sub Service
                      </label>
                      <select
                        id='subServiceTypeId'
                        name='subServiceTypeId'
                        className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                        value={subServiceTypeId}
                        onChange={(event) => {
                          setCurrentPageIndex(0);
                          setSubServiceTypeId(event.target.value);
                          setCookies(
                            "serviceOptionsSubServiceTypeId",
                            event.target.value,
                            {
                              path: "/",
                              maxAge: 300,
                            },
                          );
                        }}>
                        <option key='0' value=''>
                          Select
                        </option>
                        {subServiceOptionsData.length > 0 ? (
                          searchStatus === "DATABASE" ? (
                            subServiceOptionsData
                              .filter((item) => {
                                return [
                                  "6364ad0a314cd73283ec1a80",
                                  "6364ad0a314cd73283ec1a81",
                                ].includes(item._id);
                              })
                              .map((item) => (
                                <option key={item?._id} value={item?._id}>
                                  {item?.name}
                                </option>
                              ))
                          ) : (
                            subServiceOptionsData.map((item) => (
                              <option key={item?._id} value={item?._id}>
                                {item?.name}
                              </option>
                            ))
                          )
                        ) : (
                          <option key='1' value=''>
                            Loading...
                          </option>
                        )}
                      </select>
                    </div>
                    {(["admin", "super-admin", "manager", "lead"].includes(
                      state.user.aclGroup,
                    ) ||
                      state.user.department.name === "CRM") && (
                      <div className='w-36'>
                        <label
                          htmlFor='executive'
                          className={`block text-xs font-medium text-gray-700`}>
                          Assigned Executive
                        </label>
                        <select
                          id='executive'
                          name='executive'
                          className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                          value={executiveId}
                          onChange={(event) => {
                            setCurrentPageIndex(0);
                            setExecutiveId(event.target.value);
                            setCookies(
                              "serviceOptionsExecutiveId",
                              event.target.value,
                              {
                                path: "/",
                                maxAge: 300,
                              },
                            );
                          }}>
                          <option key='0' value=''>
                            Select
                          </option>
                          {/* {executives?.length > 0 && ( */}
                          <option value='unassigned'>Unassigned</option>
                          {/* )} */}
                          {executives?.length > 0 ? (
                            executives?.map((item) => (
                              <option key={item?._id} value={item?._id}>
                                {item?.fullname
                                  ? item.fullname
                                  : item.firstname}
                              </option>
                            ))
                          ) : (
                            <option key='1' value=''>
                              Loading...
                            </option>
                          )}
                        </select>
                      </div>
                    )}
                    <div className='w-36'>
                      <label
                        htmlFor='serviceStatus'
                        className={`block text-xs font-medium text-gray-700`}>
                        Status
                      </label>
                      <select
                        id='serviceStatus'
                        name='serviceStatus'
                        className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                        value={searchStatus}
                        onChange={(event) => {
                          setCurrentPageIndex(0);
                          setCookies(
                            "serviceOptionsSearchStatus",
                            event.target.value,
                            {
                              path: "/",
                              maxAge: 300,
                            },
                          );
                          setSearchStatus(event.target.value);
                        }}>
                        <option key='0' value=''>
                          Select
                        </option>
                        <option>All</option>
                        <option>ON-HOLD</option>
                        <option value='IN-PROCESS'>IN-PROCESS</option>
                        <option>COMPLETED</option>
                        <option>DATABASE</option>
                        <option>FOLLOW-UP</option>
                        <option>DROPPED</option>
                      </select>
                    </div>
                    <div className=''>
                      <label
                        htmlFor='channel'
                        className={`block text-xs font-medium text-gray-700`}>
                        Channel
                      </label>
                      <select
                        id='channel'
                        name='channel'
                        value={channel}
                        className={` focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm text-xs rounded-sm`}
                        onChange={(event) => {
                          setChannel(event.target.value);
                        }}>
                        <option value=''>Select</option>
                        <option value='99 acres'>99 acres</option>
                        <option value='Agent'>Agent</option>
                        <option value='BNI'>BNI</option>
                        <option value='Common Floor'>Common Floor</option>
                        <option value='Email'>Email</option>
                        <option value='Facebook'>Facebook</option>
                        <option value='Fieldwork'>Fieldwork</option>
                        <option value='Just Dial'>Just Dial</option>
                        <option value='Knowlarity'>Knowlarity</option>
                        <option value='Magic Bricks'>Magic Bricks</option>
                        <option value='Net Search'>Net Search</option>
                        <option value='Newspaper Ad'>Newspaper Ad</option>
                        <option value='Old Client'>Old Client</option>
                        <option value='Online Marketing'>
                          Online Marketing
                        </option>
                        <option value='On Site Board'>On Site Board</option>
                        <option value='Reference'>Reference</option>
                        <option value='Walk-in'>Walk-in</option>
                        <option value='Website'>Website</option>
                        <option>Others</option>
                      </select>
                    </div>
                    <div className='pt-4'>
                      <input
                        type='text'
                        name='search'
                        id='search'
                        defaultValue={searchTerm}
                        onChange={(event) => {
                          setCurrentPageIndex(0);
                          setCookies(
                            "serviceOptionsSearchTerm",
                            event.target.value,
                            {
                              path: "/",
                              maxAge: 300,
                            },
                          );
                          // searchServiceTickets(event.target.value);
                          setSearchTerm(event.target.value);
                        }}
                        placeholder='Search'
                        maxLength='20'
                        className='w-40 py-2 focus:ring-yellow-2 focus:border-yellow-2 block shadow-sm text-xs read-only:bg-gray-100 read-only:opacity-50 rounded-sm'
                      />
                    </div>
                    {["super-admin", "admin", "manager", "lead"].includes(
                      state.user.aclGroup?.toLowerCase(),
                    ) && (
                      <div className='pt-4'>
                        {!downloadData ? (
                          <button
                            type='button'
                            onClick={() => {
                              exportServiceTickets();
                            }}
                            className='duration-300 inline-flex items-center mt-.5 px-4 py-2 border border-gray-300 rounded-sm shadow-sm text-xs text-md font-medium text-black bg-yellow hover:bg-gray-dark hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'>
                            Export to Xlsx
                          </button>
                        ) : (
                          <button
                            className='animate-bounce mt-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2  duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'
                            disabled={true}>
                            Processing...
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className='flex space-x-2 sm:hidden px-4'>
                <div className='flex-col w-full'>
                  <div className='flex space-x-3 w-full'>
                    <div className='w-6/12'>
                      <label
                        htmlFor='leadFrom'
                        className='block text-xs font-medium text-gray-700'>
                        Lead From
                      </label>
                      <input
                        type='date'
                        name='leadFrom'
                        defaultValue={leadFrom}
                        id='leadFrom'
                        onChange={(event) => {
                          setCurrentPageIndex(0);
                          setLeadFrom(event.target.value);
                          setCookies(
                            "serviceOptionsLeadFrom",
                            event.target.value,
                            {
                              path: "/",
                              maxAge: 300,
                            },
                          );
                        }}
                        className=' focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm text-xs  rounded-sm'
                      />
                    </div>
                    <div className='w-6/12'>
                      <label
                        htmlFor='leadTill'
                        className='block text-xs font-medium text-gray-700'>
                        Lead Till
                      </label>
                      <input
                        type='date'
                        name='leadTill'
                        id='leadTill'
                        defaultValue={leadTill}
                        onChange={(event) => {
                          setCurrentPageIndex(0);
                          setLeadTill(event.target.value);
                          setCookies(
                            "serviceOptionsLeadTill",
                            event.target.value,
                            {
                              path: "/",
                              maxAge: 300,
                            },
                          );
                        }}
                        className=' focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm text-xs  rounded-sm'
                      />
                    </div>
                  </div>
                  <div className='flex space-x-3 mt-2'>
                    {["admin", "super-admin"].includes(state.user.aclGroup) && (
                      <div className='w-6/12'>
                        <label
                          htmlFor='serviceTypeId'
                          className={`block text-xs font-medium text-gray-700`}>
                          Service
                        </label>

                        <select
                          id='serviceTypeId'
                          name='serviceTypeId'
                          className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                          value={serviceTypeId}
                          onChange={(event) => {
                            setCurrentPageIndex(0);
                            setServiceTypeId(event.target.value);
                            setCookies(
                              "serviceOptionsServiceTypeId",
                              event.target.value,
                              {
                                path: "/",
                                maxAge: 300,
                              },
                            );
                            updateSubServiceOptions(event.target.value);
                          }}>
                          <option key='0' value=''>
                            Select
                          </option>
                          {serviceOptionsData.length > 0 ? (
                            serviceOptionsData.map((item) => (
                              <option key={item?._id} value={item?._id}>
                                {item?.name}
                              </option>
                            ))
                          ) : (
                            <option key='1' value=''>
                              Loading...
                            </option>
                          )}
                        </select>
                      </div>
                    )}
                    <div className='w-6/12'>
                      <label
                        htmlFor='subServiceTypeId'
                        className={`block text-xs font-medium text-gray-700`}>
                        Sub Service
                      </label>
                      <select
                        id='subServiceTypeId'
                        name='subServiceTypeId'
                        className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                        value={subServiceTypeId}
                        onChange={(event) => {
                          setCurrentPageIndex(0);
                          setSubServiceTypeId(event.target.value);
                          setCookies(
                            "serviceOptionsSubServiceTypeId",
                            event.target.value,
                            {
                              path: "/",
                              maxAge: 300,
                            },
                          );
                        }}>
                        <option key='0' value=''>
                          Select
                        </option>
                        {subServiceOptionsData.length > 0 ? (
                          subServiceOptionsData.map((item) => (
                            <option key={item?._id} value={item?._id}>
                              {item?.name}
                            </option>
                          ))
                        ) : (
                          <option key='1' value=''>
                            Loading...
                          </option>
                        )}
                      </select>
                    </div>
                  </div>
                  <div className='grid grid-cols-2 gap-x-3 mt-2'>
                    <div className=''>
                      <label
                        htmlFor='subServiceTypeId'
                        className={`block text-xs font-medium text-gray-700`}>
                        Status
                      </label>
                      <select
                        id='serviceStatus'
                        name='serviceStatus'
                        className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                        value={searchStatus}
                        onChange={(event) => {
                          setCurrentPageIndex(0);
                          setCookies(
                            "serviceOptionsSearchStatus",
                            event.target.value,
                            {
                              path: "/",
                              maxAge: 300,
                            },
                          );
                          setSearchStatus(event.target.value);
                        }}>
                        <option key='0' value=''>
                          Select
                        </option>
                        <option>All</option>
                        <option>ON-HOLD</option>
                        <option value='IN-PROCESS'>IN-PROCESS</option>
                        <option>COMPLETED</option>
                        <option>DATABASE</option>
                        <option>FOLLOW-UP</option>
                        <option>DROPPED</option>
                      </select>
                    </div>
                    <div className=''>
                      <label
                        htmlFor='channel'
                        className={`block text-xs font-medium text-gray-700`}>
                        Channel
                      </label>
                      <select
                        id='channel'
                        name='channel'
                        className={` focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm text-xs rounded-sm`}
                        value={channel}
                        onChange={(event) => {
                          setChannel(event.target.value);
                        }}>
                        <option value=''>Select</option>
                        <option value='99 acres'>99 acres</option>
                        <option value='Agent'>Agent</option>
                        <option value='BNI'>BNI</option>
                        <option value='Common Floor'>Common Floor</option>
                        <option value='Email'>Email</option>
                        <option value='Facebook'>Facebook</option>
                        <option value='Fieldwork'>Fieldwork</option>
                        <option value='Just Dial'>Just Dial</option>
                        <option value='Knowlarity'>Knowlarity</option>
                        <option value='Magic Bricks'>Magic Bricks</option>
                        <option value='Net Search'>Net Search</option>
                        <option value='Newspaper Ad'>Newspaper Ad</option>
                        <option value='Old Client'>Old Client</option>
                        <option value='Online Marketing'>
                          Online Marketing
                        </option>
                        <option value='On Site Board'>On Site Board</option>
                        <option value='Reference'>Reference</option>
                        <option value='Walk-in'>Walk-in</option>
                        <option value='Website'>Website</option>
                        <option>Others</option>
                      </select>
                    </div>
                    {["admin", "super-admin", "manager", "lead"].includes(
                      state.user.aclGroup,
                    ) && (
                      <div className=''>
                        <div className='w-full'>
                          <label
                            htmlFor='executive'
                            className={`block text-xs font-medium text-gray-700`}>
                            Assigned Executive
                          </label>
                          <select
                            id='executive'
                            name='executive'
                            className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                            value={executiveId}
                            onChange={(event) => {
                              setCurrentPageIndex(0);
                              setExecutiveId(event.target.value);
                              setCookies(
                                "serviceOptionsExecutiveId",
                                event.target.value,
                                {
                                  path: "/",
                                  maxAge: 300,
                                },
                              );
                            }}>
                            <option key='0' value=''>
                              Select
                            </option>
                            {/* {executives?.length > 0 && ( */}
                            <option value='unassigned'>Unassigned</option>
                            {/* )} */}
                            {executives?.length > 0 ? (
                              executives?.map((item) => (
                                <option key={item?._id} value={item?._id}>
                                  {item?.fullname
                                    ? item.fullname
                                    : item.firstname}
                                </option>
                              ))
                            ) : (
                              <option key='1' value=''>
                                Loading...
                              </option>
                            )}
                          </select>
                        </div>
                      </div>
                    )}
                    <div className='pt-4 '>
                      <input
                        type='text'
                        name='search'
                        id='search'
                        defaultValue={searchTerm}
                        onChange={(event) => {
                          // searchServiceTickets(event.target.value);
                          setCurrentPageIndex(0);
                          setCookies(
                            "serviceOptionsSearchTerm",
                            event.target.value,
                            {
                              path: "/",
                              maxAge: 300,
                            },
                          );
                          setSearchTerm(event.target.value);
                        }}
                        placeholder='Search'
                        maxLength='20'
                        className='w-full py-2 focus:ring-yellow-2 focus:border-yellow-2 block shadow-sm text-xs read-only:bg-gray-100 read-only:opacity-50 rounded-sm'
                      />
                    </div>
                  </div>
                  {["super-admin", "admin", "manager", "lead"].includes(
                    state.user.aclGroup?.toLowerCase(),
                  ) && (
                    <div className='flex space-x-2 mt-2 w-full'>
                      <div className='w-full'>
                        {!downloadData ? (
                          <button
                            type='button'
                            onClick={() => {
                              exportServiceTickets();
                            }}
                            className='duration-300 inline-flex items-center mt-.5 px-4 py-2 border border-gray-300 rounded-sm shadow-sm text-xs text-md font-medium text-black bg-yellow hover:bg-gray-dark hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'>
                            Export to Xlsx
                          </button>
                        ) : (
                          <button
                            className='animate-bounce mt-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2  duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'
                            disabled={true}>
                            Processing...
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className='px-4 py-6 sm:px-0'>
              <TailwindToaster />
              <div className='hidden md:block shadow-lg'>
                <table className='table-auto w-full shadow rounded-sm border-1 border-gray-dark'>
                  <thead className='bg-gray-50 border-b-2 border-yellow'>
                    <tr>
                      <th className='px-3 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Service&nbsp;ID
                      </th>
                      <th className='px-3 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Date
                      </th>
                      <th className='px-3 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Customer&nbsp;Name
                      </th>
                      <th className='px-3 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Mobile&nbsp;#
                      </th>
                      <th className='px-3 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Service Details
                      </th>
                      <th className='px-3 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Status
                      </th>{" "}
                      <th className='px-3 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Channel
                      </th>
                      <th className='px-3 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Team
                      </th>
                      <th></th>
                      {/* {(state.user.department !== undefined &&
                        state.user.department?.name === "CRM") ||
                        (state.user?.aclGroup === "super-admin" && (
                          <th
                            colSpan='2'
                            className='px-5 py-3 text-gray-dark text-sm font-semibold tracking-wide text-left'></th>
                        ))} */}
                    </tr>
                  </thead>
                  {refreshData !== true ? (
                    <tbody>
                      {serviceTicketData?.length > 0 ? (
                        serviceTicketData.map((item) => (
                          // index >= currentPageIndex * recordsPerPage &&
                          // index < (currentPageIndex + 1) * recordsPerPage && (
                          <tr
                            key={item?._id}
                            className='hover:shadow-lg duration-300 cursor-default'>
                            <td
                              className='px-3 py-3 font-semibold text-sm tracking-wide text-center'
                              onClick={(event) => {
                                navigate(serviceTicketUrl + "/" + item?._id, {
                                  replace: false,
                                });
                              }}>
                              #{item?.serviceTicketID}
                            </td>
                            <td
                              className='px-3 py-3 font-normal text-xs tracking-wide text-center whitespace-nowrap'
                              onClick={(event) => {
                                navigate(serviceTicketUrl + "/" + item?._id, {
                                  replace: false,
                                });
                              }}>
                              {item?.leadEnteredDate?.toString().slice(0, 10)}
                            </td>
                            <td
                              className='px-3 py-3 font-normal text-xs tracking-wide text-left'
                              onClick={(event) => {
                                navigate(serviceTicketUrl + "/" + item?._id, {
                                  replace: false,
                                });
                              }}>
                              {item?.addressBookId
                                ? item?.addressBookId?.prefix +
                                  ". " +
                                  item?.addressBookId?.firstName +
                                  " " +
                                  (item?.addressBookId?.lastName
                                    ? item?.addressBookId?.lastName
                                    : "")
                                : "--"}
                            </td>
                            <td
                              className='px-2 py-3 font-normal text-xs tracking-wide text-center whitespace-nowrap'
                              // onClick={(event) => {
                              //   navigate(serviceTicketUrl + "/" + item?._id, {
                              //     replace: false,
                              //   });
                              // }}
                            >
                              {item?.addressBookId
                                ? item?.addressBookId?.crm?._id ===
                                  "636751da314cd73283ec3671"
                                  ? "+" +
                                    item?.addressBookId?.countryCode +
                                    " " +
                                    item?.addressBookId?.phoneNumber.slice(
                                      0,
                                      2,
                                    ) +
                                    "xxx xxx" +
                                    item?.addressBookId?.phoneNumber.slice(
                                      7,
                                      10,
                                    )
                                  : ["super-admin", "admin"].includes(
                                      state.user.aclGroup?.toLowerCase(),
                                    ) ||
                                    item.assignee?.teamId?._id ===
                                      state.user?.team?._id ||
                                    state?.user?.department?._id ===
                                      "62f282e173c00d96df72aa30"
                                  ? "+" +
                                    item?.addressBookId?.countryCode +
                                    " " +
                                    item?.addressBookId?.phoneNumber
                                  : "+" +
                                    item?.addressBookId?.countryCode +
                                    " " +
                                    item?.addressBookId?.phoneNumber.slice(
                                      0,
                                      2,
                                    ) +
                                    "xxx xxx" +
                                    item?.addressBookId?.phoneNumber.slice(
                                      8,
                                      10,
                                    )
                                : "--"}
                            </td>
                            <td
                              className='px-3 py-3 font-normal text-xs tracking-wide text-center'
                              onClick={(event) => {
                                navigate(serviceTicketUrl + "/" + item?._id, {
                                  replace: false,
                                });
                              }}>
                              {item?.serviceTypeId
                                ? item?.serviceTypeId?.name
                                : "--"}{" "}
                              &gt;{" "}
                              {item?.subServiceTypeId
                                ? item?.subServiceTypeId?.name
                                : "--"}
                            </td>
                            <td className='px-3 py-3 font-semibold text-xs tracking-wide text-center'>
                              <div className='mt-0'>
                                {editStatusId !== item?._id ? (
                                  <div className='flex space-x-2 justify-center'>
                                    <div
                                      className='pl-1 mt-1 peer'
                                      onClick={(event) => {
                                        navigate(
                                          serviceTicketUrl + "/" + item?._id,
                                          {
                                            replace: false,
                                          },
                                        );
                                      }}>
                                      {renderStatus(
                                        item?.status,
                                        item?.subStatusId,
                                      )}
                                    </div>
                                    {(state?.user?.department?.name === "CRM" ||
                                      ["admin", "super-admin"].includes(
                                        state.user.aclGroup?.toLowerCase(),
                                      )) &&
                                      !["DROPPED", "COMPLETED"].includes(
                                        item?.status,
                                      ) && (
                                        <div
                                          className='ml-0 mt-0.5 opacity-0 peer-hover:opacity-100 hover:opacity-100 duration-300'
                                          onClick={(e) => {
                                            setEditStatusId(item._id);
                                          }}>
                                          <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            className='h-5 w-5'
                                            viewBox='0 0 20 20'
                                            fill='currentColor'>
                                            <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
                                          </svg>
                                        </div>
                                      )}
                                  </div>
                                ) : (
                                  <div className='mt-1 flex justify-center'>
                                    <select
                                      className={`block w-28 py-2 px-3 border bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                                      onBlur={() => {
                                        setEditStatusId(null);
                                      }}
                                      onChange={(e) => {
                                        e.preventDefault();
                                        changeServiceStatus(
                                          item._id,
                                          e.target.value,
                                        );
                                      }}
                                      value={item?.status}>
                                      <option value='DROPPED'>DROP</option>
                                      <option>ON-HOLD</option>
                                      <option>IN-PROCESS</option>
                                      <option>DATABASE</option>
                                      <option>FOLLOW-UP</option>
                                    </select>
                                  </div>
                                )}
                              </div>
                            </td>
                            <td className='px-3 py-3 font-normal text-xs tracking-wide text-center'>
                              {item?.enquiryId?.channel}
                            </td>
                            <td className='px-3 py-3 font-normal text-xs tracking-wide text-center'>
                              {item.assignee
                                ? item?.assignee?.teamId?.name
                                : "--"}
                            </td>
                            <td className='flex justify-center p-2'>
                              <Assignee
                                serviceTicketItem={item}
                                editAssigneeId={editAssigneeId}
                                setEditAssigneeId={setEditAssigneeId}
                                userState={state.user}
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr className='hover:shadow-lg duration-300'>
                          <td
                            className='px-5 py-3 font-normal text-sm tracking-wide text-center'
                            colSpan='5'>
                            No data available to display
                          </td>
                        </tr>
                      )}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
                {serviceTicketData.length > 0 && (
                  <Pagination
                    pages={totalPages}
                    currentPage={currentPageIndex}
                    recordsPerPage={recordsPerPage}
                    changePageCallback={changePageCallback}
                    totalRecords={totalRecords}
                    changeDisplayRecordCountCallback={
                      changeDisplayRecordCountCallback
                    }
                  />
                )}
              </div>
              <div className='block md:hidden'>
                {refreshData !== true ? (
                  <div className='grid grid-cols-1 gap-4'>
                    {serviceTicketData.length > 0 ? (
                      serviceTicketData.map((item) => (
                        <div
                          key={item?._id}
                          className='px-1 py-1 pb-2 shadow border-b-2 border-gray-100 z-0'>
                          <div className='grid grid-cols-6'>
                            <div className='col-span-6 flex justify-between'>
                              <div
                                className=''
                                onClick={(event) => {
                                  navigate(serviceTicketUrl + "/" + item?._id, {
                                    replace: false,
                                  });
                                }}>
                                <h4 className='text-gray-dark font-semibold text-sm tracking-wide pl-2 pt-1'>
                                  #{item?.serviceTicketID} |{" "}
                                  {item?.leadEnteredDate.slice(0, 10)}
                                </h4>
                              </div>
                              <div className='flex space-x-0.5'>
                                <h4 className='text-gray-dark font-bold text-sm tracking-wide pt-1 text-right peer'>
                                  {renderStatus(
                                    item?.status,
                                    item?.subStatusId,
                                  )}
                                </h4>
                                {(state?.user?.department?.name === "CRM" ||
                                  ["admin", "super-admin"].includes(
                                    state.user.aclGroup?.toLowerCase(),
                                  )) &&
                                  !["DROPPED", "COMPLETED"].includes(
                                    item?.status,
                                  ) && (
                                    <div
                                      className='ml-0 mt-1 opacity-0 peer-hover:opacity-100 hover:opacity-100 duration-300'
                                      onClick={(e) => {
                                        if (
                                          state?.user?.department?.name ===
                                            "CRM" ||
                                          ["admin", "super-admin"].includes(
                                            state.user.aclGroup?.toLowerCase(),
                                          )
                                        )
                                          setEditStatusId(item._id);
                                      }}>
                                      {(state?.user?.department?.name ===
                                        "CRM" ||
                                        ["admin", "super-admin"].includes(
                                          state.user.aclGroup?.toLowerCase(),
                                        )) &&
                                        !["DROPPED", "COMPLETED"].includes(
                                          item?.status,
                                        ) && (
                                          <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            className='h-4 w-4'
                                            viewBox='0 0 20 20'
                                            fill='currentColor'>
                                            <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
                                          </svg>
                                        )}
                                    </div>
                                  )}
                              </div>
                            </div>

                            <div
                              className='col-span-6'
                              onClick={(event) => {
                                navigate(serviceTicketUrl + "/" + item?._id, {
                                  replace: false,
                                });
                              }}>
                              <h4 className='text-gray-dark font-semibold text-sm tracking-wide pl-2 pt-0.5 text-left'>
                                {item?.addressBookId
                                  ? item?.addressBookId?.prefix +
                                    ". " +
                                    item?.addressBookId?.firstName +
                                    " " +
                                    (item?.addressBookId?.lastName
                                      ? item?.addressBookId?.lastName
                                      : "")
                                  : "--"}
                              </h4>
                            </div>
                            <div
                              className='col-span-6 overflow-x-scroll'
                              onClick={(event) => {
                                navigate(serviceTicketUrl + "/" + item?._id, {
                                  replace: false,
                                });
                              }}>
                              <h4 className='text-gray-dark font-normal text-xs tracking-wide pl-2 pt-0.5 text-left overflow-hidden'>
                                {item?.serviceTypeId?.name} &gt;{" "}
                                {item?.subServiceTypeId?.name}
                              </h4>
                            </div>
                            <div className='col-span-4'>
                              <div
                              // onClick={(event) => {
                              //   navigate(serviceTicketUrl + "/" + item?._id, {
                              //     replace: false,
                              //   });
                              // }}
                              >
                                <div className='flex flex-col gap-2'>
                                  <h4 className='text-gray-dark font-normal text-xs tracking-wide pl-2 pt-0.5 text-left'>
                                    {(item?.addressBookId
                                      ? item?.addressBookId?.crm?._id ===
                                        "636751da314cd73283ec3671"
                                        ? "+" +
                                          item?.addressBookId?.countryCode +
                                          " " +
                                          item?.addressBookId?.phoneNumber.slice(
                                            0,
                                            2,
                                          ) +
                                          "XXX XX" +
                                          item?.addressBookId?.phoneNumber.slice(
                                            7,
                                            10,
                                          )
                                        : "+" +
                                          item?.addressBookId?.countryCode +
                                          " " +
                                          item?.addressBookId?.phoneNumber
                                      : "--") +
                                      " | " +
                                      item?.enquiryId?.channel}
                                  </h4>
                                  <div className='pl-2'>
                                    <Assignee
                                      serviceTicketItem={item}
                                      editAssigneeId={editAssigneeId}
                                      setEditAssigneeId={setEditAssigneeId}
                                      userState={state.user}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            {
                              ((state.user.department !== undefined &&
                                state.user.department.name.toLowerCase() ===
                                  "crm") ||
                                ["super-admin", "admin"].includes(
                                  state.user.aclGroup,
                                )) &&
                                editStatusId === item?._id && (
                                  <div className='mt-0'>
                                    <select
                                      className={`block w-28 py-1 px-2 border bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                                      onBlur={() => {
                                        setEditStatusId(null);
                                      }}
                                      onChange={(e) => {
                                        e.preventDefault();
                                        if (
                                          state?.user?.department?.name ===
                                            "CRM" ||
                                          ["admin", "super-admin"].includes(
                                            state.user.aclGroup?.toLowerCase(),
                                          )
                                        )
                                          changeServiceStatus(
                                            item._id,
                                            e.target.value,
                                          );
                                      }}
                                      value={item?.status}>
                                      <option value='DROPPED'>DROP</option>
                                      <option>ON-HOLD</option>
                                      <option>IN-PROCESS</option>
                                      <option>DATABASE</option>
                                      <option>FOLLOW-UP</option>
                                    </select>
                                  </div>
                                )
                              // //If In-service
                              // (item?.status !== "DROPPED" ? (
                              //   item?.status === "IN-PROCESS" ? (
                              //     <div className='col-span-2 pb-2 pr-3'>
                              //       <div className='grid grid-cols-2 gap-2'>
                              //         <div className='z-50'>
                              //           <h4
                              //             onClick={() => {
                              //               changeServiceStatus(
                              //                 item?._id,
                              //                 "ON-HOLD",
                              //               );
                              //             }}
                              //             className='font-semibold text-sm text-yellow-2 text-right pr-2'>
                              //             HOLD
                              //           </h4>
                              //         </div>
                              //         <div className='z-50'>
                              //           <h4
                              //             onClick={() => {
                              //               changeServiceStatus(
                              //                 item?._id,
                              //                 "DROPPED",
                              //               );
                              //             }}
                              //             className='font-semibold text-sm text-red-600 text-right pr-2'>
                              //             DROP
                              //           </h4>
                              //         </div>
                              //       </div>
                              //     </div>
                              //   ) : (
                              //     <div className='col-span-2 pb-2 pr-3'>
                              //       <div className='grid grid-cols-2 gap-2'>
                              //         <div className='z-50'>
                              //           <h4
                              //             onClick={() => {
                              //               changeServiceStatus(
                              //                 item?._id,
                              //                 "IN-PROCESS",
                              //               );
                              //             }}
                              //             className={`font-semibold text-xs ${
                              //               item?.status === "FOLLOW-UP"
                              //                 ? " text-green-800"
                              //                 : " text-yellow-2"
                              //             } text-right pr-2`}>
                              //             {item?.status === "FOLLOW-UP"
                              //               ? "IN-PROCESS"
                              //               : "REVOKE"}
                              //           </h4>
                              //         </div>
                              //         <div className='z-50'>
                              //           <h4
                              //             onClick={() => {
                              //               changeServiceStatus(
                              //                 item?._id,
                              //                 "DROPPED",
                              //               );
                              //             }}
                              //             className='font-semibold text-xs text-red-600 text-right pr-2'>
                              //             DROP
                              //           </h4>
                              //         </div>
                              //       </div>
                              //     </div>
                              //   )
                              // ) : (
                              //   <></>
                              // ))
                            }
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className='px-3 py-2'>
                        <h4 className='text-lg font-semibold'>
                          No data to display
                        </h4>
                      </div>
                    )}
                    {serviceTicketData.length > 0 && (
                      <Pagination
                        pages={totalPages}
                        currentPage={currentPageIndex}
                        recordsPerPage={recordsPerPage}
                        changePageCallback={changePageCallback}
                        totalRecords={totalRecords}
                        changeDisplayRecordCountCallback={
                          changeDisplayRecordCountCallback
                        }
                      />
                    )}
                  </div>
                ) : (
                  <div className='grid grid-cols-1 gap-4 '>
                    <div className='flex animate-pulse flex-col items-left h-full justify-center border-b-2 pb-1 border-gray-100'>
                      <div className='flex flex-row gap-2'>
                        <div className='w-5/12 bg-yellow-2 h-6 rounded-md '></div>
                        <div className='w-7/12 bg-gray-200 h-6 rounded-md '></div>
                      </div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='flex flex-row gap-2 mt-2'>
                        <div className='w-8/12 bg-gray-100 h-8 rounded-md '></div>
                        <div className='w-4/12 bg-yellow-2 h-8 rounded-md '></div>
                      </div>
                    </div>
                    <div className='flex animate-pulse flex-col items-left h-full justify-center mt-1 border-b-2 pb-1 border-gray-100'>
                      <div className='flex flex-row gap-2'>
                        <div className='w-5/12 bg-yellow-2 h-6 rounded-md '></div>
                        <div className='w-7/12 bg-gray-200 h-6 rounded-md '></div>
                      </div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='flex flex-row gap-2 mt-2'>
                        <div className='w-8/12 bg-gray-100 h-8 rounded-md '></div>
                        <div className='w-4/12 bg-yellow-2 h-8 rounded-md '></div>
                      </div>
                    </div>
                    <div className='flex animate-pulse flex-col items-left h-full justify-center mt-1 border-b-2 pb-1 border-gray-100'>
                      <div className='flex flex-row gap-2'>
                        <div className='w-5/12 bg-yellow-2 h-6 rounded-md '></div>
                        <div className='w-7/12 bg-gray-200 h-6 rounded-md '></div>
                      </div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='w-full bg-gray-100 h-4 rounded-md mt-2 '></div>
                      <div className='flex flex-row gap-2 mt-2'>
                        <div className='w-8/12 bg-gray-100 h-8 rounded-md '></div>
                        <div className='w-4/12 bg-yellow-2 h-8 rounded-md '></div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default Service;
